import EquipmentCreate from '_modules/equipment/views/EquipmentCreate.vue';
import EquipmentEdit from '_modules/equipment/views/EquipmentEdit.vue';
import EquipmentList from '_modules/equipment/views/EquipmentList.vue';
import Equipment from './Root.vue';

export default {
  path: 'equipamentos/',
  component: Equipment,
  name: 'admin-equipment',
  redirect: '/equipamentos/lista/1',
  children: [
    {
      path: 'lista/:page',
      name: 'admin-equipment-list',
      component: EquipmentList,
    },
    {
      path: 'novo/',
      name: 'admin-equipment-new',
      component: EquipmentCreate,
    },
    {
      path: ':equipmentId',
      name: 'admin-equipment-edit',
      component: EquipmentEdit,
    },
  ],
};
